"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchHeaderTitle = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchHeaderTitle = (param)=>{
    let { isRootPath } = param;
    const { translations, formatMessage } = (0, _hooks.useTranslations)();
    const { query, totalCount } = (0, _contexts.useSearchResultContext)();
    const { getTestId } = (0, _testidGenerator.default)();
    if (isRootPath) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
            isDefault: true,
            "data-testid": getTestId('top-banner-title'),
            children: translations.hiHowCanWeHelp
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
        "data-testid": getTestId('top-banner-title'),
        children: formatMessage('nResultsForQuery', {
            count: totalCount,
            query
        })
    });
};
exports.SearchHeaderTitle = SearchHeaderTitle;
